export default __webpack_public_path__ + "static/media/793-cryptologically.24828ef6.pdf";